import { cn } from "@/lib/utils"
import type { OptimizerParamGroups } from "../types/optimizer"

export interface OptimizerConfigRangesProps {
  ranges: OptimizerParamGroups
  className?: string
}

export function OptimizerConfigRanges({
  ranges,
  className,
}: OptimizerConfigRangesProps) {
  return (
    <div className={cn("flex flex-col gap-3 pl-2", className)}>
      {Object.entries(ranges).map(([group, params]) => (
        <div key={group}>
          <h4 className="text-caption font-semibold text-foreground mb-1">
            {group}
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-0.5">
            {params.map((p) => (
              <div
                key={p.label}
                className="flex items-center gap-2 text-caption py-0.5 min-w-0"
              >
                <span className="text-muted-foreground whitespace-nowrap">
                  {p.label}:
                </span>
                <span className="text-foreground font-semibold truncate">
                  {p.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
